module.exports = __webpack_public_path__ + "img/gebratenenudelnohnehintergrund.0e775145.png";